import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';

import { ValidationFormField } from '@eb/eds-validation-form-field';
import { InputField } from '@eb/eds-input-field';
import { IconButton } from '@eb/eds-icon-button';
import { RefreshChunky } from '@eb/eds-iconography';

import { shouldDisplayError } from '@eb/redux-form-tools';

import './emailField.scss';

export default class EmailField extends Component {
    static propTypes = {
        buttonClasses: PropTypes.string,
        submitFailed: PropTypes.bool,
        isStatic: PropTypes.bool,
        autoFocus: PropTypes.bool,
        onBlur: PropTypes.func,
        onFormReset: PropTypes.func,
    };

    render() {
        const {
            buttonClasses,
            isStatic,
            onBlur,
            onFormReset,
            autoFocus,
        } = this.props;
        let resetButton = null;
        // User are unable to login when the page is loading, due to "dynamic" style of the input.
        // When a loading state for LookUpForm component were implemented, we should remove this prop.
        const style = isStatic ? 'static' : 'dynamic';
        if (onFormReset) {
            resetButton = (
                <IconButton
                    iconType={<RefreshChunky />}
                    onClick={onFormReset}
                    title={gettext('Reset Form')}
                />
            );
        }

        return (
            <div className={buttonClasses}>
                <ValidationFormField
                    name="email"
                    shouldDisplayError={shouldDisplayError}
                    v2={true}
                >
                    <InputField
                        id="email"
                        name="email"
                        label={gettext('Email address')}
                        type="email"
                        role="textbox"
                        style={style}
                        onBlur={onBlur}
                        data-automation="authentication-email-field"
                        suffix={resetButton}
                        autoFocus={autoFocus}
                    />
                </ValidationFormField>
            </div>
        );
    }
}
